import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { DeliveryChannels } from "@/payroll/pay-breakdown/payroll-statement-notifications/delivery-channels";
import { DeliveryStatus } from "@/payroll/pay-breakdown/payroll-statement-notifications/delivery-status";
import type { PayrollStatementNotificationRecipient } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import {
  formatNotificationTimestamp,
  getDeliveryTimestamp,
} from "@/payroll/pay-breakdown/payroll-statement-notifications/utils";

export const StatusCol = (): ColumnDef<
  PayrollStatementNotificationRecipient,
  unknown
> => ({
  id: "status",
  enableSorting: false,
  header: () => <span>Last sent</span>,
  cell: ({ row }) => {
    const latestTimestamp = formatNotificationTimestamp(
      getDeliveryTimestamp(row.original.latest_delivery),
    );

    return (
      <Stack align="start" gap={1}>
        <Stack direction="row" align="center" gap={2}>
          <DeliveryStatus delivery={row.original.latest_delivery} />
          {row.original.latest_delivery && (
            <DeliveryChannels delivery={row.original.latest_delivery} />
          )}
        </Stack>
        {latestTimestamp && (
          <Text variant="caption" tone="muted">
            {latestTimestamp}
          </Text>
        )}
      </Stack>
    );
  },
});
